import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos');
import { OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

.pos-home {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
}

.home-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
  box-shadow: var(--pos-shadow);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-datetime {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.hd-date {
  font-size: 14px;
  font-weight: 500;
  color: var(--pos-text);
}

.hd-sep {
  font-size: 14px;
  color: var(--pos-text-dim);
}

.hd-time {
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--pos-accent);
  letter-spacing: 1px;
}

.header-center {
  flex: 1;
  text-align: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--pos-text);
}

.header-right {
  width: 120px;
}

.home-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.closed-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(6px);
}

.closed-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 0 24px rgba(34, 197, 94, 0.4);
}
.closed-icon .icon-svg {
  width: 40px;
  height: 40px;
}

.closed-text {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.92);
}

.loading-spinner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 5px solid #e5e7eb;
  border-top-color: var(--pos-accent);
  animation: spin 0.8s linear infinite;
  margin-bottom: 18px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.loading-text {
  font-size: 17px;
  color: #374151;
  font-weight: 600;
}

.error-overlay {
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
}

.error-icon {
  margin-bottom: 16px;
  color: #ef4444;
}
.error-icon .icon-svg {
  width: 56px;
  height: 56px;
}

.error-text {
  font-size: 17px;
  color: #374151;
  margin-bottom: 20px;
  font-weight: 500;
}

.error-retry {
  padding: 12px 32px;
  border-radius: 10px;
  border: 2px solid #ef4444;
  background: #fff;
  color: #ef4444;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
}
.error-retry:hover, .error-retry:active {
  background: #ef4444;
  color: #fff;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: var(--pos-text-dim);
}

.empty-icon {
  margin-bottom: 8px;
  opacity: 0.4;
  color: var(--pos-text-dim);
}
.empty-icon .icon-svg {
  width: 36px;
  height: 36px;
}

.empty-text {
  font-size: 13px;
  font-weight: 500;
}

.dashboard-area {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.dashboard-area::-webkit-scrollbar {
  width: 4px;
}
.dashboard-area::-webkit-scrollbar-thumb {
  background: var(--pos-border);
  border-radius: 4px;
}

.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  flex-shrink: 0;
}

.kpi-card {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: all 200ms;
}
.kpi-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.kpi-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.kpi-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.kpi-icon-wrap svg {
  width: 18px;
  height: 18px;
}
.kpi-icon-wrap.icon-blue {
  background: rgba(74, 158, 255, 0.1);
}
.kpi-icon-wrap.icon-blue svg {
  stroke: #4a9eff;
}
.kpi-icon-wrap.icon-green {
  background: rgba(52, 199, 89, 0.1);
}
.kpi-icon-wrap.icon-green svg {
  stroke: #34c759;
}
.kpi-icon-wrap.icon-orange {
  background: rgba(255, 149, 0, 0.1);
}
.kpi-icon-wrap.icon-orange svg {
  stroke: #ff9500;
}
.kpi-icon-wrap.icon-purple {
  background: rgba(175, 82, 222, 0.1);
}
.kpi-icon-wrap.icon-purple svg {
  stroke: #af52de;
}

.kpi-trend {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
}
.kpi-trend.trend-up {
  color: #34c759;
  background: rgba(52, 199, 89, 0.1);
}
.kpi-trend.trend-down {
  color: #ff3b30;
  background: rgba(255, 59, 48, 0.1);
}

.kpi-sub {
  font-size: 10px;
  color: var(--pos-text-dim);
}

.kpi-body {
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-wrap: wrap;
}

.kpi-label {
  width: 100%;
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text-dim);
  letter-spacing: 0.3px;
  margin-bottom: -2px;
}

.kpi-value {
  font-size: 26px;
  font-weight: 800;
  color: var(--pos-text);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.5px;
  line-height: 1.1;
}

.kpi-unit {
  font-size: 13px;
  font-weight: 500;
  color: var(--pos-text-dim);
}

.kpi-progress {
  margin-top: 4px;
}

.kpi-progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: var(--pos-text-dim);
  margin-bottom: 4px;
}

.kpi-progress-bar {
  width: 100%;
  height: 6px;
  background: var(--pos-card);
  border-radius: 3px;
  overflow: hidden;
}

.kpi-progress-fill {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #4a9eff, #6366f1);
  transition: width 600ms ease;
}

.kpi-table-bar {
  display: flex;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 4px;
}

.tbar-seg {
  height: 100%;
}

.tbar-occupied {
  background: var(--pos-accent);
}

.tbar-reserved {
  background: var(--pos-orange, #f59e0b);
}

.tbar-empty {
  background: var(--pos-card);
}

.kpi-table-legend {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.tl-item {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  color: var(--pos-text-dim);
}

.tl-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.dot-occ {
  background: var(--pos-accent);
}

.dot-res {
  background: var(--pos-orange, #f59e0b);
}

.dot-emp {
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
}

.chart-row {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 12px;
  flex-shrink: 0;
}

.chart-card {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pos-border);
}

.card-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--pos-text);
}

.card-sub {
  font-size: 10px;
  color: var(--pos-text-dim);
}

.card-more {
  font-size: 11px;
  color: var(--pos-accent);
  font-weight: 600;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}
.card-more:hover {
  background: rgba(74, 158, 255, 0.08);
}

.chart-body {
  flex: 1;
  padding: 12px 16px 10px;
}

.bar-chart {
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 144px;
}

.bar-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 100%;
}

.bar-track {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 0;
}

.bar-fill {
  width: 100%;
  max-width: 32px;
  border-radius: 4px 4px 0 0;
  background: linear-gradient(180deg, var(--pos-accent), rgba(74, 158, 255, 0.5));
  position: relative;
  min-height: 4px;
  transition: height 600ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.bar-tip {
  position: absolute;
  top: -16px;
  font-size: 9px;
  font-weight: 600;
  color: var(--pos-accent);
  white-space: nowrap;
}

.bar-label {
  font-size: 10px;
  color: var(--pos-text-dim);
  font-weight: 500;
  flex-shrink: 0;
}

.payment-body {
  flex: 1;
  padding: 14px 16px;
  display: flex;
  gap: 14px;
  align-items: center;
}

.donut-wrap {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.donut-svg {
  width: 100%;
  height: 100%;
}

.donut-bg {
  stroke: var(--pos-card);
}

.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.donut-total {
  font-size: 13px;
  font-weight: 800;
  color: var(--pos-text);
  line-height: 1.1;
}

.donut-label {
  font-size: 9px;
  color: var(--pos-text-dim);
}

.payment-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pl-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pl-color {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.pl-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.pl-name {
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text);
  line-height: 1.2;
}

.pl-ratio {
  font-size: 10px;
  color: var(--pos-text-dim);
}

.pl-amount {
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text-dim);
  white-space: nowrap;
}

.bottom-row {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 12px;
  flex-shrink: 0;
}

.orders-body {
  padding: 6px 0;
  overflow-y: auto;
  max-height: 200px;
}

.order-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  font-size: 12px;
  transition: background 100ms;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.order-row:hover {
  background: var(--pos-hover, rgba(59, 130, 246, 0.04));
}

.or-id {
  font-weight: 700;
  color: var(--pos-accent);
  min-width: 48px;
}

.or-table {
  background: var(--pos-card);
  padding: 1px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 11px;
  flex-shrink: 0;
}

.or-items {
  flex: 1;
  color: var(--pos-text-dim);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.or-amount {
  font-weight: 700;
  color: var(--pos-text);
  min-width: 72px;
  text-align: right;
}

.or-method {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 3px;
  background: var(--pos-card);
  color: var(--pos-text-dim);
  flex-shrink: 0;
}

.or-time {
  font-size: 11px;
  color: var(--pos-text-dim);
  min-width: 36px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.menus-body {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mr-rank {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
  background: var(--pos-card);
  color: var(--pos-text-dim);
  border: 1px solid var(--pos-border);
}
.mr-rank.rank-1 {
  background: linear-gradient(135deg, #ffd700, #ffb800);
  color: #fff;
  border: none;
  box-shadow: 0 2px 6px rgba(255, 184, 0, 0.3);
}
.mr-rank.rank-2 {
  background: linear-gradient(135deg, #c0c0c0, #a8a8a8);
  color: #fff;
  border: none;
}
.mr-rank.rank-3 {
  background: linear-gradient(135deg, #cd7f32, #b8691a);
  color: #fff;
  border: none;
}

.mr-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--pos-text);
  min-width: 72px;
}

.mr-bar-wrap {
  flex: 1;
  height: 8px;
  background: var(--pos-card);
  border-radius: 4px;
  overflow: hidden;
}

.mr-bar {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--pos-accent), rgba(74, 158, 255, 0.5));
  transition: width 600ms ease;
}

.mr-qty {
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text);
  min-width: 32px;
  text-align: right;
}

.mr-amount {
  font-size: 11px;
  color: var(--pos-text-dim);
  min-width: 68px;
  text-align: right;
}

.home-menu {
  width: 160px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: var(--pos-panel);
  border-left: 1px solid var(--pos-border);
}

.home-menu-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 6px;
  border-radius: 10px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  cursor: pointer;
  transition: all 150ms;
  user-select: none;
}
.home-menu-btn:hover {
  background: var(--btn-color, var(--pos-accent));
  color: #fff;
  border-color: var(--btn-color, var(--pos-accent));
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.home-menu-btn:hover .hm-icon ::ng-deep svg {
  stroke: #fff;
}
.home-menu-btn:active {
  transform: scale(0.97);
}
.home-menu-btn .hm-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-menu-btn .hm-icon ::ng-deep svg {
  width: 24px;
  height: 24px;
  stroke: var(--btn-color, var(--pos-accent));
  transition: stroke 150ms;
}
.home-menu-btn .hm-label {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--pos-modal-backdrop, rgba(0, 0, 0, 0.3));
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 150ms ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.modal-box {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 12px;
  width: 380px;
  max-width: calc(100vw - 32px);
  animation: slideUp 200ms ease;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid var(--pos-border);
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
}

.modal-close {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-close .icon-svg {
  width: 18px;
  height: 18px;
}
.modal-close:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}

.modal-body {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shutdown-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 10px;
  border: 1px solid;
  background: transparent;
  color: var(--pos-text);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
}
.shutdown-btn:active {
  transform: scale(0.97);
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-icon .icon-svg {
  width: 22px;
  height: 22px;
}

.btn-exit {
  border-color: var(--pos-red, #ef4444);
}
.btn-exit:hover {
  background: rgba(239, 68, 68, 0.1);
}

.btn-restart {
  border-color: var(--pos-accent);
}
.btn-restart:hover {
  background: rgba(59, 130, 246, 0.1);
}`],
})
export class PagePosComponent implements OnInit, OnDestroy {
    public showShutdownModal = false;
    public closedMessage = '';
    public isLoading = true;
    public errorMessage = '';

    private rawMenuItems = [
        {
            label: '판매관리', path: '/pos/sales', color: '#4a9eff',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
        },
        {
            label: '영업관리', path: '/pos/business', color: '#34c759',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>'
        },
        {
            label: '매출현황', path: '/pos/revenue', color: '#ff9500',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>'
        },
        {
            label: '수발주관리', path: '/pos/orders', color: '#af52de',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>'
        },
        {
            label: '환경설정', path: '/pos/settings', color: '#8e8e93',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>'
        },
        {
            label: '고객주문', path: '/pos/customer', color: '#0f766e',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
        },
        {
            label: '시스템 종료', path: '', color: '#ff3b30',
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>'
        },
    ];

    public menuItems: { label: string; path: string; color: string; safeSvg: SafeHtml }[] = [];

    // ─── 시계 ───
    public currentDate: string = '';
    public currentTime: string = '';
    private clockInterval: any;

    // ─── 대시보드 데이터 ───
    public todaySales = 0;
    public todayOrders = 0;
    public avgOrderAmount = 0;
    public tableUseRate = 0;
    public yesterdaySales = 0;
    public todayTarget = 2500000;
    public hourlySales: any[] = [];
    public paymentBreakdown: any[] = [];
    public tableStats = { total: 0, occupied: 0, empty: 0, reserved: 0 };
    public recentOrders: any[] = [];
    public topMenus: any[] = [];

    constructor(@Inject( Service)         public service: Service,@Inject( DomSanitizer)         private sanitizer: DomSanitizer,    ) {}

    async ngOnInit() {
        await this.service.init(this);
        this.menuItems = this.rawMenuItems.map(item => ({
            ...item,
            safeSvg: this.sanitizer.bypassSecurityTrustHtml(item.svg)
        }));
        this.startClock();
        await this.loadDashboard();
        await this.checkUnclosedBusiness();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.clockInterval) clearInterval(this.clockInterval);
    }

    private startClock() {
        this.updateClock();
        this.clockInterval = setInterval(() => this.updateClock(), 1000);
    }

    private async checkUnclosedBusiness() {
        try {
            let res: any = await wiz.call('unclosed_business_check');
            if (res.code === 200 && res.data?.hasUnclosed) {
                this.closedMessage = `${res.data.businessDate} 영업일이 마감되지 않았습니다. 마감처리를 진행해주세요.`;
            }
        } catch (e) {}
    }

    private updateClock() {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        const day = days[now.getDay()];
        const h = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');
        this.currentDate = `${y}.${m}.${d} (${day})`;
        this.currentTime = `${h}:${min}:${s}`;
    }

    async onMenuClick(item: any) {
        if (item.label === '시스템 종료') {
            this.showShutdownModal = true;
            await this.service.render();
            return;
        }
        if (item.path === '/pos/customer') {
            window.location.assign('/pos/customer');
            return;
        }
        if (item.path) {
            this.service.href(item.path);
        }
    }

    async closeShutdownModal() {
        this.showShutdownModal = false;
        await this.service.render();
    }

    async onShutdown() {
        window.close();
    }

    public formatCurrency(v: number) {
        return (Number(v) || 0).toLocaleString();
    }

    public salesProgress() {
        if (!this.todayTarget) return 0;
        return Math.min(100, Math.round((this.todaySales / this.todayTarget) * 100));
    }

    private async loadDashboard() {
        this.isLoading = true;
        this.errorMessage = '';
        try {
            const res: any = await wiz.call('dashboard');
            if (res.code === 200) {
                const data = res.data?.data || {};
                this.todaySales = data.todaySales || 0;
                this.todayOrders = data.todayOrders || 0;
                this.avgOrderAmount = data.avgOrderAmount || 0;
                this.tableUseRate = data.tableUseRate || 0;
                this.yesterdaySales = data.yesterdaySales || 0;
                this.todayTarget = data.todayTarget || 2500000;
                this.hourlySales = data.hourlySales || [];
                this.paymentBreakdown = data.paymentBreakdown || [];
                this.tableStats = data.tableStats || this.tableStats;
                this.recentOrders = data.recentOrders || [];
                this.topMenus = data.topMenus || [];
            } else {
                this.errorMessage = res.data?.message || '대시보드 데이터를 불러오지 못했습니다.';
            }
        } catch (error) {
            this.errorMessage = '대시보드 데이터를 불러오지 못했습니다.';
        }
        this.isLoading = false;
    }
}

export default PagePosComponent;